import React from 'react';

import {
  DIMENSION_CREATIVE,
  DIMENSION_CONCEPT,
  DIMENSION_END_CARD,
  DIMENSION_TOTALS,
} from 'scenes/Trackers/Tracker/constants';

import ConceptActions from './ConceptActions';
import CreativeActions from './CreativeActions';

const Actions = ({ data }) => {
  const { type } = data;

  if (data?.Dimension?.id === DIMENSION_TOTALS) {
    return null;
  }
  if (data.isTotalValue) {
    return null;
  }
  switch (type) {
    case DIMENSION_CREATIVE:
    case DIMENSION_END_CARD:
      return <CreativeActions rowData={data} />;

    case DIMENSION_CONCEPT:
      return <ConceptActions rowData={data} />;
    default:
      return null;
  }
};

export default Actions;
